import React from 'react'
import PrismStyles from './prism'

export default {
  PrismStyles,
}
